import { LicenseModuleEnum } from "./LicenseModuleEnum";

export class LicenseModuleSummary {
    module: LicenseModuleEnum;
    totalLicenses: number;
    assignedLicenses: number;

    get availableLicenses(): number {
        return this.totalLicenses - this.assignedLicenses;
    }

    public parse(obj: any) {
        if (obj.Module != null && Object.values(LicenseModuleEnum).includes(obj.Module)) this.module = obj.Module;
        if (obj.TotalLicenses >= 0) this.totalLicenses = obj.TotalLicenses;
        if (obj.AssignedLicenses >= 0) this.assignedLicenses = obj.AssignedLicenses;
    }
}
